import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

/* ── Portaled context menu (cursor / anchor positioned) ─────────────────── */

export function CtxMenu({ pos, items, onClose }) {
  const menuRef = useRef(null);

  useEffect(() => {
    const onMouseDown = (e) => {
      if (menuRef.current?.contains(e.target)) return;
      onClose();
    };
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [onClose]);

  const left = Math.max(8, Math.min(pos.x, window.innerWidth - 190));
  const top = Math.max(8, Math.min(pos.y, window.innerHeight - (items.length * 32 + 20)));

  return ReactDOM.createPortal(
    <div
      ref={menuRef}
      className="ftp-ctx-menu fixed z-50 min-w-40 animate-fadeIn rounded-lg border border-gray-200 bg-white py-2 shadow-lg dark:border-zinc-700 dark:bg-zinc-900"
      style={{ left, top }}
      onContextMenu={(e) => e.preventDefault()}
    >
      {items.map(({ id, label, Icon, danger, onSelect }) => (
        <button
          key={id}
          type="button"
          className={`ctx-menu-btn${danger ? ' ctx-menu-btn--danger' : ''}`}
          onClick={() => {
            onClose();
            onSelect();
          }}
        >
          <Icon size={14} />
          <span>{label}</span>
        </button>
      ))}
    </div>,
    document.body
  );
}
